import type { IconName } from "@narmi/design_system/dist/types/types/Icon.types";

export const OnboardingPromptStatus = {
  completed: "completed",
  inProgress: "in_progress",
} as const;

// To-do CBD 541, 542, 544 - add remaining event names
export const OnboardingEventName = {
  LINK_EXTERNAL_ACCOUNT: "link_external_account",
  ENABLE_ESTATEMENTS: "enable_estatements",
  ADD_SECONDARY_MFA: "add_secondary_mfa",
  ENABLE_BIOMETRICS: "enable_biometrics",
  ADD_SUB_USERS: "add_sub_users",
  ADD_ALERTS: "add_alerts",
  SET_UP_DIRECT_DEPOSIT: "set_up_direct_deposit",
  SET_UP_PUSH_PROVISIONING: "set_up_push_provisioning",
  SET_UP_BUSINESS_ACH_PAYMENT: "ach_payment",
  SET_UP_BUSINESS_RECURRING_ACH_PAYMENT: "recurring_ach_payment",
  INCOME_REPORTING: "report_income_source",
  ADD_BILL_PAY_PAYEE: "add_bill_pay_payee",
  MAKE_BILL_PAYMENT: "make_bill_payment",
} as const;

export type OnboardingStatusType =
  (typeof OnboardingPromptStatus)[keyof typeof OnboardingPromptStatus];

export type OnboardingEventNameType =
  (typeof OnboardingEventName)[keyof typeof OnboardingEventName];

export type OnboardingEventCallbackMap = Partial<
  Record<OnboardingEventNameType, () => void>
>;

export type OnboardingPlatform = "app" | "web";

export type GuideType = "onboarding" | "existing";
export type GuidePlatform = OnboardingPlatform;
export type UserGuideType = "onboarding" | "existing" | null;

export type OnboardingPrompt = {
  id: string;
  uuid: string;
  title: string;
  description: string;
  link: string;
  link_text: string;
  event_name: OnboardingEventNameType;
  icon_name: IconName;
  platforms: OnboardingPlatform[];
  status: OnboardingStatusType;
};

export type OnboardingPromptResponse = {
  id: string;
  title: string;
  description: string;
  guide_type: GuideType;
  platforms: GuidePlatform[];
  prompts: OnboardingPrompt[];
};
